import React, { useState, useEffect } from 'react';
import { getCategories } from '../services/api';

function TestCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);

        // Use centralized API service (reads from REACT_APP_API_URL)
        const response = await getCategories();
        setCategories(response.data || []);
        setError('');
      } catch (err) {
        setError(err.message || 'Failed to load categories');
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Test Categories Component</h1>
      
      {loading && <p>Loading categories...</p>}
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 p-4 rounded mb-4">
          Error: {error}
        </div>
      )}
      
      <div>
        <h2 className="text-xl font-semibold mb-2">Categories:</h2>
        {categories.length === 0 ? (
          <p>No categories found.</p>
        ) : (
          <ul className="list-disc pl-5">
            {categories.map(category => (
              <li key={category.id || category.ID} className="mb-1">
                {category.name || category.Name}: {category.description || category.Description}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default TestCategories; 